<template>
  <div v-if="DocumentTypeId && ObjectId">
    <dropzone
      ref="dropZoneUpload"
      id="myVueDropzone"
      @vdropzone-queue-complete="queueComplete"
      :duplicateCheck="true"
      :useCustomSlot="true"
      :options="dropzoneOptions">
      {{$t('UPLOAD_TEXT')}}
    </dropzone>
  </div>
</template>

<script>
  import {API_CONFIG} from '@/services/config'
  import Dropzone from 'vue2-dropzone'
  import {toast} from "@/shared/plugins/toastr";
  import 'vue2-dropzone/dist/vue2Dropzone.min.css'
  import {getErrorMessage} from '@/mixins/error/getErrorMessage'
  import {DOCUMENT_URL} from "@/services/endpoints";

  export default {
    name: "DocumentUpload",
    mixins: [getErrorMessage],
    props: {
      ObjectId: {
        type: Number,
        required: true
      },
      DocumentTypeId: {
        type: Number,
        required: true
      },
      DocumentType: {
        default: 'image/*,application/pdf, application/msword, application/octet-stream,application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        type: String
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        dropzoneOptions: {
          url: API_CONFIG.API_URL + DOCUMENT_URL + `/${this.DocumentTypeId}/${this.ObjectId}`,
          method: 'post',
          acceptedFiles: this.DocumentType,
          autoProcessQueue: true,
          paramName: 'list',
          uploadMultiple: true,
          addRemoveLinks: false,
          dictDefaultMessage: "<i class='fa fa-cloud-upload'></i>UPLOAD ME",
          dictFallbackMessage: "<i class='fa fa-cloud-upload'></i>UPLOAD ME",
          parallelUploads: 1,
          headers: {
            "Cache-Control": "",
            "X-Requested-With": "",
            "Authorization": 'Bearer ' + this.$store.getters['auth/getToken'],
          }
        }
      }
    },
    components: {
      Dropzone
    },
    methods: {
      endUploadError() {
        //this.$refs.dropZoneUpload.enable()
        toast({
          'title': "Error",
          'message': "Error in upload",
          'type': "error",
          'timeout': 5000
        })
      },
      queueComplete() {
        toast({
          'title': "Success",
          'message': "Upload complete",
          'type': "success",
          'timeout': 5000
        })
        this.$refs.dropZoneUpload.removeAllFiles();
        this.$emit('uploadSuccess')
      }
    }
  }
</script>

<style scoped>

</style>
